import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import zh from './locales/zh.json';

const resources = {
  en: {
    translation: en
  },
  'en-US': {
    translation: en
  },
  zh: {
    translation: zh
  },
  'zh-CN': {
    translation: zh
  },
  'zh-TW': {
    translation: zh
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // 默认语言为英文  
    supportedLngs: ['en', 'en-US', 'zh', 'zh-CN', 'zh-TW'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    // lng: 'en', // 让语言检测器自动检测初始语言
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false // React已经默认转义
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
